import { GATEWAY_URL, ENV, BUILD_NAME } from "../env";
import request from "./Request";

class RemoteConfigService {
    static instance = null;
    
    static webglBuildConfig = {};
    static landingConfig = {};
    static downloadButtons = {};
    static toastAppStoreCountries = {};
    
    static webGLBuildConfigKey = "webgl_build";
    static landingConfigKey = "LandingConfig";
    static downloadButtonsKey = "DownloadButtons";
    static toastAppStoreCountriesKey = "ToastAppStoreCountries";

    static async init() {
        if (!RemoteConfigService.instance) {
            RemoteConfigService.instance = new RemoteConfigService();
        }
        await RemoteConfigService.instance.loadConfig();
        return RemoteConfigService.instance;
    }

    async loadConfig() {        
        try {
            console.log("[RemoteConfig] Loading config ...");
            
            const response = await request.GET(`${GATEWAY_URL}/AuthService/GetRemoteConfig`);

            if (response !== null && response[RemoteConfigService.webGLBuildConfigKey] !== null) {
              RemoteConfigService.webglBuildConfig = response[RemoteConfigService.webGLBuildConfigKey];
              console.log("[RemoteConfig] Config loaded with webglBuildConfig: ", RemoteConfigService.webglBuildConfig);
            }
            
            if (response !== null && response[RemoteConfigService.landingConfigKey] !== null) {
              RemoteConfigService.landingConfig = response[RemoteConfigService.landingConfigKey];
              console.log("[RemoteConfig] Config loaded with landingConfig: ", RemoteConfigService.landingConfig);
            }

            if (response !== null && response[RemoteConfigService.downloadButtonsKey] !== null) {
                RemoteConfigService.downloadButtons = response[RemoteConfigService.downloadButtonsKey];
                console.log("[RemoteConfig] Config loaded with downloadButtons: ", RemoteConfigService.downloadButtons);
            }

            if (response !== null && response[RemoteConfigService.toastAppStoreCountriesKey] !== null) {
                RemoteConfigService.toastAppStoreCountries = response[RemoteConfigService.toastAppStoreCountriesKey];
                console.log("[RemoteConfig] Config loaded with toastAppStoreCountries: ", RemoteConfigService.toastAppStoreCountries);
            }

        } catch (error) {
            console.error("[RemoteConfig] Error loading remote config:", error);
        }
    }
    
    static getWebGLBuildNameByEnvironment() {
        if (BUILD_NAME !== "") {
            return BUILD_NAME;
        }
        
        if (!RemoteConfigService.webglBuildConfig) {
            console.error("[RemoteConfig] webglBuildConfig is null. Call RemoteConfigService.init() first.");
            return null;
        }

        if (!RemoteConfigService.webglBuildConfig[ENV.toString()]) {
            console.error("[RemoteConfig] webglBuildConfig does not have webgl_build for env ", ENV);
            return null;
        }

        console.log("[RemoteConfig] WebGL build name for env", ENV, "is", RemoteConfigService.webglBuildConfig[ENV.toString()]);
        return RemoteConfigService.webglBuildConfig[ENV.toString()];
    }
    
    static getLandingConfigValue(key) {
      if (!RemoteConfigService.landingConfig) {
        console.error("[RemoteConfig] landingConfig is null. Call RemoteConfigService.init() first.");
        return null;
      }

      if (!RemoteConfigService.landingConfig[key]) {
        console.error("[RemoteConfig] landingConfig does not have value with key ", key);
        return null;
      }
      
      return RemoteConfigService.landingConfig[key];
    }
    
    static getToastAppStoreCountries() {
        if (!RemoteConfigService.toastAppStoreCountries) {
            console.error("[RemoteConfig] toastAppStoreCountries is null. Call RemoteConfigService.init() first.");
            return null;
        }

        if (!RemoteConfigService.toastAppStoreCountries["CountryCodes"]) {
            console.error("[RemoteConfig] toastAppStoreCountries does not have value with CountryCodes key");
            return null;
        }

        return RemoteConfigService.toastAppStoreCountries["CountryCodes"];
    }

    static getDownloadButtons() {
        if (!RemoteConfigService.downloadButtons) {
            console.error("[RemoteConfig] downloadButtons is null. Call RemoteConfigService.init() first.");
            return null;
        }

        if (!RemoteConfigService.downloadButtons["buttons"]) {
            console.error("[RemoteConfig] downloadButtons does not have value with buttons key");
            return null;
        }

        return RemoteConfigService.downloadButtons["buttons"];
    }
}

export default RemoteConfigService;
